import React from "react";

const Card = ({ children, wMax }) => {
  return (
    <div
      className={`backdrop-blur-sm bg-white/50 p-6 ${
        wMax ? "w-[500px]" : "w-96"
      }`}
    >
      {children}
    </div>
  );
};

export default Card;
